import { SelectOptions } from "../ui/Select";
import React from "react";
import { GridSwitcher } from "./GridSwitcher";

export const FilterSearchSortBar = ({isActiveView, setActiveView}) => {
    return (
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-2">
            <div className="w-full rounded-lg px-2 top-[60px] z-10 bg-surface-950 py-4 mb-4 border-b-2 border-surface-900">
                <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:max-w-none overflow-x-auto pb-2 lg:pb-0">

                    {/* Moved GridSwitcher here to position it left in the row layout */}
                    <GridSwitcher activeView={isActiveView} setActiveView={setActiveView} />

                    <div className="hidden md:block flex-grow" />
                    <div className="flex items-center gap-4 flex-shrink-0">
                        {/*<SearchBar />*/}
                        <CategoryFilter />
                    </div>

                </div>
            </div>
        </div>
    );
};

export const CategoryFilter = () => {
    const optionsArr = ['All Categories', 'Characters', 'Weapons', 'Environment', 'UI (user interface)'];
    return (
        <div className="relative" id="category-dropdown">
            <div className="w-full sm:w-auto flex gap-4">

                <SelectOptions sizing="large">
                    {optionsArr.map((opt) => <option key={opt}>{opt}</option>)}
                </SelectOptions>

            </div>
        </div>
    );
};







